import styled from "styled-components";
import NextSection from "../general/NextSection";
import { colors } from "../../assets/colors";
import { useCursorHandlers, useSectionCursor } from "../general/Cursor";
import { useState } from "react";

import logo from "../../assets/logo.png";
import neha0 from "../../assets/headshots/neha0.png";
import neha1 from "../../assets/headshots/neha1.png";
import ryan0 from "../../assets/headshots/ryan0.png";
import ryan1 from "../../assets/headshots/ryan1.png";
import lucas0 from "../../assets/headshots/lucas0.png";
import lucas1 from "../../assets/headshots/lucas1.png";
import riya0 from "../../assets/headshots/riya0.png";
import riya1 from "../../assets/headshots/riya1.png";
import ronnie0 from "../../assets/headshots/ronnie0.png";
import ronnie1 from "../../assets/headshots/ronnie1.png";
import saood0 from "../../assets/headshots/saood1.jpeg";
import athena0 from "../../assets/headshots/athena1.jpg";
import akhilesh0 from "../../assets/headshots/akhilesh1.jpg";
import rasikaPatel from "../../assets/headshots/RasikaPatel_Headshot.png";
import preyanshJain from "../../assets/headshots/PreyanshJain_Headshot.jpg";
import anshuSiripurapu from "../../assets/headshots/AnshuSiripurapu_Headshot.jpg";
import rohailMoti from "../../assets/headshots/RohailMoti_Headshot.png";
import alanSchwartz from "../../assets/headshots/AlanSchwartz_Headshot.jpg";
import jacobAbraham from "../../assets/headshots/JacobAbraham_Headshot.jpg";
import jordanLubowitz from "../../assets/headshots/JordanLubowitz_Headshot.jpg";


const SectionContainer = styled.div`
  width: 100vw;
  background-color: ${colors.black};
  display: flex;
  flex-wrap: wrap;
  position: relative;
  align-items: center;
  justify-content: center;
  top: 0px;
  max-width: 100%;
`;

const TextContainer = styled.div`
  width: 100%;
  text-align: center;
`;

const TitleText = styled.h1`
  display: inline-block;
  font-size: 5vmin;
  font-family: ReadexPro, sans-serif;
  margin: 5vh 0 0 0;
  padding: 0;
  font-weight: 700;
  text-align: center;
  color: ${colors.red};
`;

const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(4, auto);
  grid-template-rows: 1fr;
  width: fit-content;
  height: 100%;
  align-items: center;
  justify-items: center;
  position: relative;
  margin-top: 6vh;
  margin-bottom: 5vh;
  gap: 2vmin;
  margin-left: auto;
  margin-right: auto;
`;

const CardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1vmin;
`;

const ImageFrame = styled.div`
  width: 27vmin;
  height: 27vmin;
  border: 2.5px solid ${colors.white};
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
`;

const CardImage = styled.div`
  background-image: url(${logo});
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
`;

const CardImageHover = styled.div`
  background-image: url(${logo});
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  transition: opacity 0.3s;
`;

const CardTitle = styled.h1`
  display: inline-block;
  font-size: 2.4vmin;
  font-family: ReadexPro, sans-serif;
  margin: 0;
  padding: 0;
  font-weight: 700;
  text-align: center;
  color: ${colors.white};
  @media only screen and (max-width: 700px) {
    font-size: 3.6vmin;
  }
`;

const CardText = styled.p`
  display: inline-block;
  font-size: 2vmin;
  font-family: ReadexPro, sans-serif;
  margin: 0;
  padding: 0;
  font-weight: 400;
  text-align: center;
  color: ${colors.white};
  @media only screen and (max-width: 700px) {
    font-size: 2.8vmin;
  }
`;

const data = [
  {
    name: "Anshu Siripurapu",
    img0: anshuSiripurapu,
    img1: anshuSiripurapu,
    title: "Co-President",
    url: "https://www.linkedin.com/in/anshusiripurapu/",
    ID: 10
  },
  {
    name: "Preyansh Jain",
    img0: preyanshJain,
    img1: preyanshJain,
    title: "Co-President",
    url: "https://www.linkedin.com/in/preyanshjain/",
    ID: 5,
    imagePosition: "center 50%"
  },
  {
    name: "Alan Schwartz",
    img0: alanSchwartz,
    img1: alanSchwartz,
    title: "VP External",
    url: "https://www.linkedin.com/in/alan-schwartz-989319285/",
    ID: 11
  },
  // {
  //   name: "Max Chen",
  //   img0: saood0,
  //   img1: saood0,
  //   title: "Executive VP",
  //   url: "https://www.linkedin.com/in/maxchen/",
  //   ID: 7
  // },
  {
    name: "Jacob Abraham",
    img0: jacobAbraham,
    img1: jacobAbraham,
    title: "VP Internal",
    url: "https://www.linkedin.com/in/jacobjabraham/",
    ID: 11
  },
  
  // {
  //   name: "Akhilesh Bitla",
  //   img0: akhilesh0,
  //   img1: akhilesh0,
  //   title: "VP of Special Projects",
  //   url: "https://www.linkedin.com/in/akhileshbitla/",
  //   ID: 9
  // },

  
  
  
  // {
  //   name: "Jordan Lubowitz",
  //   img0: jordanLubowitz,
  //   img1: jordanLubowitz,
  //   title: "VP of Marketing",
  //   url: "https://www.linkedin.com/in/jordandaniellubowitz/",
  //   ID: 11
  // },
  // {
  //   name: "Rohail Moti",
  //   img0: rohailMoti,
  //   img1: rohailMoti,
  //   title: "VP of Outreach",
  //   url: "https://www.linkedin.com/in/rohailmoti/",
  //   ID: 8
  // }
  //   {
  //   name: "Rasika Patel",
  //   img0: rasikaPatel,
  //   img1: rasikaPatel,
  //   title: "VP Marketing",
  //   url: "https://www.linkedin.com/in/rasikapatel/",
  //   ID: 11
  // },
  
]

function Text() {
  const sectionCursorHandlers = useSectionCursor({color: colors.white});
  const cursorHandlers = useCursorHandlers();
  const [hoverID, setHoverID] = useState(0);
  
  return ( 
    <SectionContainer {...sectionCursorHandlers}>
      <TextContainer>
        <TitleText>Executive Board</TitleText>
      </TextContainer>
      <Cards>
        {data.map((person, index) => (
          <a
            href={person.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
            {...cursorHandlers}
          >
            <CardContainer>
              <ImageFrame
                onMouseEnter={() => setHoverID(person.ID)}
                onMouseLeave={() => setHoverID(0)}
              >
                <CardImage
                  style={{
                    backgroundImage: `url(${person.img0})`,
                    backgroundPosition: person.imagePosition || "center top",
                  }}
                />
                <CardImageHover
                  style={{
                    opacity: hoverID === person.ID ? 1 : 0,
                    backgroundImage: `url(${person.img1})`,
                    backgroundPosition: person.imagePosition || "center top",
                  }}
                />
              </ImageFrame>
              <CardTitle>{person.name}</CardTitle>
              <CardText>{person.title}</CardText>
            </CardContainer>
          </a>
        ))}
      </Cards>
    </SectionContainer>
  );
}

export default Text;